import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, OnDestroy, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router, RouterOutlet } from '@angular/router';
import { Observable } from 'rxjs';

import { TimelineService } from '@models/milestone-category/milestone/timeline.service';
import { TrialInsightsStore } from '@models/trial-insights/trial-insights.store';

import { LaunchDarklyService } from '@shared/services/launch-darkly.service';

import { TrialInsightsNavComponent } from './components/trial-insights-nav/trial-insights-nav.component';
import { TrialInsightsService } from './services/trial-insights.service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TrialInsightsNavComponent, RouterOutlet, AsyncPipe],
  styleUrls: ['./trial-insights.component.scss'],
  templateUrl: './trial-insights.component.html',
})
export class TrialInsightsComponent implements OnDestroy, OnInit {
  private launchDarklyService = inject(LaunchDarklyService);
  private router = inject(Router);
  private store = inject(TrialInsightsStore);
  private timelineService = inject(TimelineService);
  private trialInsights = inject(TrialInsightsService);

  mainElement = document.querySelector('main');

  modified = () => {
    if (
      this.mainElement &&
      !this.trialInsights.getBackgroundColor() &&
      this.router.url.includes('trial-insights')
    ) {
      this.trialInsights.changeBackground(true);
    }
  };

  observer = new MutationObserver(this.modified);
  showClinOpsButton$: Observable<boolean>;
  showFinanceButton$: Observable<boolean>;

  ngOnInit(): void {
    this.trialInsights.changeBackground(true);
  }

  ngOnDestroy(): void {
    this.observer.disconnect();
    this.trialInsights.changeBackground(false);
    this.store.reset();
  }

  constructor() {
    this.showFinanceButton$ = this.launchDarklyService.select$((flags) => flags.finance_dashboard);
    this.showClinOpsButton$ = this.launchDarklyService.select$((flags) => flags.clin_ops_dashboard);

    if (this.mainElement && this.observer) {
      this.observer.observe(this.mainElement, { attributes: true });
    }

    this.timelineService.getTimelineItems().pipe(takeUntilDestroyed()).subscribe();
  }
}
